import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import { produce } from "immer";
import { headApi } from "utils/headApi";
import { imgApi } from "utils/imgApi";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Check from "@material-ui/icons/Check";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import style from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import styleCheck from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";
import { localApi, inshaApi } from "utils/imgApi";

import { credentials } from "utils/imgApi";

const useStyles = makeStyles(styles);
const useStyle = makeStyles(style);
const useStyleSweet = makeStyles(styleSweet);
const useStyCheck = makeStyles(styleCheck);

export default function AddSet(props) {
  const [descName, setDescName] = React.useState("");
  const [pcs, setPcs] = React.useState("");
  const [descErr, setDescErr] = React.useState("");
  const [pcsErr, setPcsErr] = React.useState("");
  const [items, setItems] = React.useState([]);

  const [submitted, setSubmitted] = React.useState(false);
  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");

  const [newSets, setNewSets] = React.useState(false);
  const [btn, setBtn] = React.useState(false);

  const [active, setActive] = React.useState(false);
  const [multipleSelect, setMultipleSelect] = React.useState([]);
  const [newDefChild, setNewDefChild] = React.useState(false);
  const [multipleSelectErr, setMultipleSelectErr] = React.useState("");

  const classes = useStyles();
  const classe = useStyle();
  const classSweet = useStyleSweet();
  const classCheck = useStyCheck();

  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  async function getUsers() {
    const api =
      inshaApi + `/sets/list/byAdminId/2`;
    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const getResult = await result.json();
    setItems(getResult && getResult);
    // console.log(getResult);
  }

  useEffect(() => {
    getUsers();
  }, []);

  const handleMultiple = event => {
    setMultipleSelect(event.target.value);
    setMultipleSelectErr("")
  };

  const handleDescName = (index) => (e) => {
    let setDesc = e.target.value;
    setMultipleSelect((curlab) =>
      produce(curlab, (v) => {
        v[index].setDesc = setDesc;
      })
    );
  };

  const handlePcs = (index) => (e) => {
    let pcs = e.target.value;
    setMultipleSelect((curlab) =>
      produce(curlab, (v) => {
        v[index].pcs = pcs;
      })
    );
  };

  const SubmitAddDefaultSets = (e) => {
    setNewDefChild(true);
    let errorCount = 0;
    if (!Array.isArray(multipleSelect) || multipleSelect.length < 2) {
      errorCount++;
      setMultipleSelectErr("Select at least two Product Sets");
    }
    if (errorCount === 0) {
      // console.log(multipleSelect.map((m) => {
      //   return {
      //     setDesc: m.setDesc,
      //     pcs: m.pcs,
      //   }
      // }));

      setBtn(true);
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Basic ${credentials}`,
        },
        body: JSON.stringify(multipleSelect.map((m) => {
          return {
            setDesc: m.setDesc,
            pcs: m.pcs,
          }
        })),
      };
      fetch(localApi + `/sets/addAll/${userObj.id}`, requestOptions)
        .then((res) => res.json())
        .then((data) => {
          // console.log(data);
          if (data.message === "Data Inserted Successfully!") {
            alertTypeOps("success");
            alertMsgOps("Succesfully !!!");
            setSubmitted(true);
          }
        });
    }
  }

  const SubmitAddSet = () => {
    setNewSets(true);
    let errorCount = 0;
    if (descName === "" || !descName) {
      errorCount++;
      setDescErr("Description Name is Required");
    }

    if (pcs === "" || !pcs) {
      errorCount++;
      setPcsErr("Piece/Sets is Required");
    }

    if (errorCount === 0) {
      setBtn(true);
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Basic ${credentials}`,
        },
        body: JSON.stringify({
          setDesc: descName,
          pcs: pcs,
        }),
      };

      fetch(localApi + `/sets/add/${userObj && userObj.id}`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          // console.log(data)
          if (data.message === "Data Inserted Successfully !!!") {
            alertTypeOps("success");
            alertMsgOps("Succesfully !!!");
            setSubmitted(true);
          }
        });
    }
  };

  const hideAlert = () => {
    setSubmitted(false);
    window.location.reload(false);
  };

  return (
    <div>
      <GridContainer justify="center" alignItems="center">
        <GridItem xs={12} sm={active === true ? 12 : 12} md={active === true ? 12 : 6}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <AddIcon />
              </CardIcon>
              <h3 className={classes.cardIconTitle}>
                <small>Add Piece/Sets</small>
                {active === true ? newDefChild === true ? (
                  <small
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginLeft: "10px",
                    }}
                  >
                    {multipleSelectErr}
                  </small>
                ) : (
                  <small style={{ fontSize: "12px", marginLeft: "10px" }}>
                    Enter Sets Description
                  </small>
                ) : newSets === true ? (
                  <small
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginLeft: "10px",
                    }}
                  >
                    {descErr || pcsErr}
                  </small>
                ) : (
                  <small style={{ fontSize: "12px", marginLeft: "10px" }}>
                    Enter Sets Description
                  </small>
                )}
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer>
                {submitted ? (
                  <SweetAlert
                    type={alertType}
                    style={{ display: "block", marginTop: "-100px" }}
                    title={alertMsg}
                    onConfirm={() => hideAlert()}
                    confirmBtnCssClass={
                      classSweet.button + " " + classSweet.success
                    }
                  >
                    Added Sets
                  </SweetAlert>
                ) : null}{" "}
                {active === false ? <>
                  <GridItem xs={12} sm={6} md={6}>
                    <CustomInput
                      labelText="Descriptions Name..."
                      id="descName"
                      inputProps={{
                        placeholder: "Eg: 2 Pcs in 1 Set...",
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="descName"
                      value={descName}
                      onChange={(e) => {
                        setDescName(e.target.value);
                        setDescErr("");
                      }}
                      required={true}
                    />
                    {/* <span style={{ color: "red" }}>{descErr}</span> */}
                  </GridItem>
                  <GridItem xs={12} sm={6} md={6}>
                    <CustomInput
                      labelText="Piece/Sets..."
                      id="pcs"
                      inputProps={{
                        placeholder: "Ex. 2...",
                      }}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      name="pcs"
                      value={pcs}
                      onChange={(e) => {
                        setPcs(e.target.value);
                        setPcsErr("");
                      }}
                      required={true}
                    />
                    {/* <span style={{ color: "red" }}>{pcsErr}</span> */}
                  </GridItem></> : ""}
                <GridItem xs={12} sm={12} md={12}>
                  <FormControlLabel
                    classes={{
                      root: classCheck.checkboxLabelControl,
                      label: classCheck.checkboxLabel,
                    }}
                    control={
                      <Checkbox
                        id="active"
                        value={active}
                        checked={
                          active & (active === true) ? active : active
                        }
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setActive(checked);
                          if (!checked) {
                            // If checkbox is unchecked, clear multipleSelect
                            setMultipleSelect([]);
                            setMultipleSelectErr(""); // Also clear any errors if needed
                          }
                        }}
                        tabIndex={-1}
                        checkedIcon={
                          <Check className={classCheck.checkedIcon} />
                        }
                        icon={
                          <Check className={classCheck.uncheckedIcon} />
                        }
                        classes={{
                          checked: classCheck.checked,
                          root: classCheck.checkRoot,
                        }}
                      />
                    }
                    label={
                      <span style={{ color: "#9c27b0" }}>
                        Would you like to save the default Sets?
                      </span>
                    }
                  />
                </GridItem>
                {active === true ?
                  <GridItem xs={12} sm={12} md={12}>
                    <FormControl
                      fullWidth
                      className={classe.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="multiple-select"
                        className={classe.selectLabel}
                      >
                        Select Piece/Sets...
                      </InputLabel>
                      <Select
                        multiple
                        value={multipleSelect}
                        onChange={handleMultiple}
                        MenuProps={{ className: classe.selectMenu }}
                        classes={{ select: classe.select }}
                        inputProps={{
                          name: "multipleSelect",
                          id: "multiple-select"
                        }}
                      >
                        <MenuItem
                          disabled
                          classes={{
                            root: classe.selectMenuItem
                          }}
                        >
                          Select Piece/Sets...
                        </MenuItem>
                        {items &&
                          items.map((item2) => (
                            <MenuItem
                              key={item2.id}
                              value={item2}
                              classes={{
                                root: classe.selectMenuItem,
                                selected: classe.selectMenuItemSelectedMultiple,
                              }}
                            >
                              {item2.setDesc}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </GridItem>
                  : ""}
              </GridContainer>

              <GridContainer>
                {multipleSelect &&
                  multipleSelect.map((Ele, index) => (
                    <GridItem xs={12} sm={6} md={4} key={Ele.id} value={Ele.id}>
                      <Card>
                        <CardBody>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                              <CustomInput
                                labelText={"Descriptions Name..." + Ele.id}
                                id="descName"
                                inputProps={{
                                  placeholder: "Ex. 1 Pcs...",
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                name="descName"
                                value={Ele.setDesc}
                                onChange={handleDescName(index)}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                              <CustomInput
                                labelText={"Piece/Sets..."}
                                id="pcs"
                                inputProps={{
                                  placeholder: "Ex. 1...",
                                }}
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                name="pcs"
                                value={Ele.pcs}
                                onChange={handlePcs(index)}
                              />
                            </GridItem>
                          </GridContainer>
                        </CardBody>
                      </Card>
                    </GridItem>
                  ))}
              </GridContainer>
              {/* <Button
                color="rose"
                onClick={SubmitAddSet}
                className={classes.updateProfileButton}
              >
                Save
              </Button> */}
              {btn === true ? (
                <Button className={classes.updateProfileButton}>Save</Button>
              ) : (
                active === true ? (
                  <Button
                    color="rose"
                    onClick={SubmitAddDefaultSets}
                    className={classes.updateProfileButton}
                  >
                    Save Default
                  </Button>
                ) :
                  <Button
                    color="rose"
                    onClick={SubmitAddSet}
                    className={classes.updateProfileButton}
                  >
                    Save
                  </Button>
              )}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
